import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setItemDraft, setItemOptionsDraft } from '../../actions/ItemAction';
import NoxTable from '../../component/Table';

const ItemOptionsEdit = (props) => {
  const { columns, selectedRowKeys, setSelectedRowKeys, data } = props;
  const dispatch = useDispatch();
  const actions = [];
  const itemOptionsDraft = useSelector(({ item }) => item.itemOptionsDraft);
  const itemDraft = useSelector(({ item }) => item.itemDraft);

  const onOptionDelete = () => {
    const newOptionsArray = [...itemOptionsDraft];
    selectedRowKeys.map((option) => newOptionsArray.splice(option, 1));
    dispatch(setItemOptionsDraft(newOptionsArray));
    dispatch(setItemDraft({ ...itemDraft, options: newOptionsArray }));
    setSelectedRowKeys([]);
  };

  if (selectedRowKeys.length) {
    actions.unshift({
      disabled: false,
      onClick: onOptionDelete,
      title: 'Delete',
      type: 'primary'
    });
  }
  return (
    <div>
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        searchBy="title"
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default ItemOptionsEdit;
